export default {
	props: {
		provider: {
			type: Object,
			required: true
		}
	}
}
